var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M98.2,21.4L40.9,78.7l-21-21c-1-1-2.7-1-3.7,0L10,63.8c-1,1-1,2.7,0,3.7l29,29c1,1,2.7,1,3.7,0L108,31.3c1-1,1-2.7,0-3.7 l-6.2-6.2C100.8,20.4,99.2,20.4,98.2,21.4z"}})}
var staticRenderFns = []

export { render, staticRenderFns }